export const SUN_DISTANCE: number = 50000;
export const EARTH_RADIUS: number = 6378;
export const GSO_RADIUS: number = 35786; 
export const DEFAULT_EASY_VIEW_SCALE: number = 1500;
export const MAX_SCALE: number = 4000;
export const IS_IOS = false;